import React from "react"
import styled from "styled-components"
import Line from './line'
import Code from './images/code'
const Wrapper = styled.div`
    display: grid;
    grid-template-columns: 408px 1fr;
    grid-gap: 3rem;

  @media(max-width: 919px) {
    grid-template-columns: 1fr;
    grid-gap: 1rem;

  }
  @media(min-width: 1826px){
    min-height: 700px;

  }

` 
const WrapperContent = styled.div`
    max-width: 408px;
    color: #FFF;
    padding-top: 70px;
    padding-bottom: 150px;
    @media(max-width: 919px) {
      display: flex;
      flex-direction: column;
      max-width: 100%;
      padding-bottom: 20px;

      padding-top: 0;
  }
  
`
const Title = styled.h2`
  font-size: 2.37rem;
  line-height: 50px;
  margin-bottom: 15px;
  @media(max-width: 919px) {
    text-align: center;
  }
`
const Description = styled.p`
  font-weight: 300;
  font-size: 1rem;
  line-height: 25px;

  @media(max-width: 919px) {
    text-align: center;
  }
`
const ImgWrapper = styled.div`
  align-self: flex-end;
  @media(max-width: 919px){
      margin-top: 40px;
    }
    @media(min-width: 1826px){
      position: absolute;
      width: 906px;
      left: 450px;
      bottom: 0;
    }
`

const Ux = ({ handle }) => (
   <section className="mSection bgPrimary" style={{marginTop: 0, paddingTop: '60px'}}>
            <div className="container" id="experiencia" data-aos='zoom-out' data-aos-duration="600">
              <Wrapper>
               
                <WrapperContent>
                 <Title>Desenvolvimento <br />& programação</Title>
                 <Line width="10px" align="flex-start" />
                 <Description>Utilizamos a metodologia ágil Scrum, dividindo o projeto em ciclos de Sprints.</Description>
                 <Description>Além disso, empregamos linguagens de programação avançadas, nas quais os desenvolvedores tiveram mais versatilidade para trabalhar nas soluções.</Description>
                </WrapperContent>
                <ImgWrapper data-aos='fade-up' data-aos-duration="600">
                  <Code />
                  
                </ImgWrapper>
                </Wrapper>
            </div>
          </section>
 )
export default Ux
